'use strict';

angular.module('clientDashboardApp').service('localeService', function ($q, $http) {

  function LocaleService() {
  }

  LocaleService.prototype.updateDefaultLocale = function(localeSetting) {
    var deferred = $q.defer();

    $http
      .put('/user/updateLocale',localeSetting)
      .success(function (data, status, headers, config) {
        deferred.resolve(data);
      })
      .error(function (data, status, headers, config) {
        deferred.reject('Error occurred while retrieving users!');
      });

    return deferred.promise;
  };

  var localeService = new LocaleService();
  return localeService;
});
